///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2022
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import getLeastProgressedMode from "./getLeastProgressedMode";
import getOrdinalNumber from "./getOrdinalNumber";
import { repType, status, userRole } from "./types";
import messages from "./messages";

export const getBidTags = (bid, user) => {
  let bidTags = [];

  if (
    (user.role === userRole.salesRep ||
      user.userRoleForManagementUser === userRole.salesRep) &&
    bid.modes.some(mode => mode.status === status.rejected)
  ) {
    bidTags.push({
      tag: messages.rejected.defaultMessage,
      testId: "rejected-tag"
    });
  } else {
    const mode = getLeastProgressedMode(bid.modes, user);

    if (
      mode.status === status.inProgress &&
      mode.isLaneUploadComplete &&
      bid.round === 1
    ) {
      bidTags.push({
        tag: messages.lanesImported.defaultMessage,
        testId: "lanes-imported-tag"
      });
    }

    if (bid.modes.length > 1) {
      bidTags.push({
        tag: messages.multimode.defaultMessage,
        testId: "multimode-tag"
      });
    }

    if (mode.status >= status.inProgress) {
      if (bid.round > 1) {
        bidTags.push({
          tag: `${getOrdinalNumber(bid.round)} ${
            messages.round.defaultMessage
          }`,
          testId: "round-tag"
        });
      }
    }

    if (
      (user.role === userRole.tlPricingAnalyst ||
        user.role === userRole.assetBasedPricingUser ||
        user.userRoleForManagementUser === userRole.tlPricingAnalyst ||
        user.userRoleForManagementUser === userRole.assetBasedPricingUser) &&
      bid.bidOwnerRepType === repType.sales
    ) {
      bidTags.push({
        tag: messages.salesOnly.defaultMessage,
        testId: "sales-only-tag"
      });
    }
  }
  return bidTags;
};

export default getBidTags;
